var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainNavBar'),_c('Hero',{attrs:{"hero":_vm.heroBuildingKnowledgeAccelerator}}),_c('SectionTrinpodServer'),_c('SectionTrinappSuite'),_c('CallToAction',{attrs:{"content":_vm.buildingCTA}}),_c('GmxFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }